export const seoMetadata = {
  "/": {
    title: "The Romanelli Group | Central Ohio Realtors",

    description:
      "Helping buyers and sellers across Central Ohio achieve their real estate goals with trusted local expertise, personalized guidance, and exceptional service.",

    keywords:
      "Central Ohio Realtors, Columbus Ohio real estate, homes for sale Columbus, buy a home Ohio, sell a home Ohio, Keller Williams Greater Columbus, The Romanelli Group",

    ogTitle:
      "The Romanelli Group | Central Ohio Realtors",

    ogDescription:
      "Helping Central Ohio families buy and sell with confidence through local expertise, integrity, and exceptional service.",

    ogImage:
      "https://www.theromanelligroup.com/og-image.jpg",
  },

  "/buy": {
    title: "Buy a Home in Central Ohio | The Romanelli Group",

    description:
      "Search homes for sale across Central Ohio with expert guidance from The Romanelli Group. From your first showing to closing day, we're here to help.",

    keywords:
      "buy home Columbus Ohio, homes for sale Central Ohio, Columbus Realtor, home buying, Ohio real estate",

    ogTitle:
      "Buy a Home in Central Ohio | The Romanelli Group",

    ogDescription:
      "Find your dream home with trusted local experts serving Central Ohio.",

    ogImage:
      "https://www.theromanelligroup.com/og-image.jpg",
  },

  "/sell": {
    title: "Sell Your Home | The Romanelli Group",

    description:
      "Sell your Central Ohio home with confidence. The Romanelli Group combines local market expertise, strategic marketing, and proven negotiation to maximize your home's value.",

    keywords:
      "sell home Columbus Ohio, Central Ohio Realtor, home valuation, listing agent, Keller Williams",

    ogTitle:
      "Sell Your Home | The Romanelli Group",

    ogDescription:
      "Maximize your home's value with trusted Central Ohio real estate experts.",

    ogImage:
      "https://www.theromanelligroup.com/og-image.jpg",
  },

  "/contact-us": {
    title: "Contact The Romanelli Group",

    description:
      "Ready to buy or sell a home? Contact The Romanelli Group for trusted real estate guidance throughout Central Ohio.",

    keywords:
      "contact Realtor Columbus Ohio, Central Ohio real estate agent, Romanelli Group",

    ogTitle:
      "Contact The Romanelli Group",

    ogDescription:
      "We're here to help you buy, sell, or invest with confidence.",

    ogImage:
      "https://www.theromanelligroup.com/og-image.jpg",
  },

  "/properties": {
    title: "Central Ohio Property Listings | The Romanelli Group",

    description:
      "Browse homes and real estate listings across Central Ohio. Discover your next home with The Romanelli Group.",

    keywords:
      "Central Ohio homes, Columbus listings, Ohio homes for sale, real estate listings",

    ogTitle:
      "Central Ohio Property Listings | The Romanelli Group",

    ogDescription:
      "Explore homes for sale throughout Central Ohio.",

    ogImage:
      "https://www.theromanelligroup.com/og-image.jpg",
  },

  "/resources": {
    title: "Real Estate Resources | The Romanelli Group",

    description:
      "Stay informed with buying guides, selling tips, market updates, and expert real estate advice from The Romanelli Group.",

    keywords:
      "Central Ohio real estate blog, home buying guide, home selling tips, Columbus housing market",

    ogTitle:
      "Real Estate Resources | The Romanelli Group",

    ogDescription:
      "Expert real estate insights, buying guides, and market updates for Central Ohio.",

    ogImage:
      "https://www.theromanelligroup.com/og-image.jpg",
  },

  "/privacy-policy": {
    title: "Privacy Policy | The Romanelli Group",
    description: "Privacy Policy for The Romanelli Group.",
    keywords: "",
    ogTitle: "Privacy Policy | The Romanelli Group",
    ogDescription: "Privacy Policy for The Romanelli Group.",
    ogImage: "https://www.theromanelligroup.com/og-image.jpg",
    noindex: true,
  },

  "/terms-of-use": {
    title: "Terms of Use | The Romanelli Group",
    description: "Terms of Use for The Romanelli Group.",
    keywords: "",
    ogTitle: "Terms of Use | The Romanelli Group",
    ogDescription: "Terms of Use for The Romanelli Group.",
    ogImage: "https://www.theromanelligroup.com/og-image.jpg",
    noindex: true,
  },

  "/cookie-policy": {
    title: "Cookie Policy | The Romanelli Group",
    description: "Cookie Policy for The Romanelli Group.",
    keywords: "",
    ogTitle: "Cookie Policy | The Romanelli Group",
    ogDescription: "Cookie Policy for The Romanelli Group.",
    ogImage: "https://www.theromanelligroup.com/og-image.jpg",
    noindex: true,
  },

  "/dmca-notice": {
    title: "DMCA Notice | The Romanelli Group",
    description: "DMCA Notice for The Romanelli Group.",
    keywords: "",
    ogTitle: "DMCA Notice | The Romanelli Group",
    ogDescription: "DMCA Notice for The Romanelli Group.",
    ogImage: "https://www.theromanelligroup.com/og-image.jpg",
    noindex: true,
  },

  "/fair-housing": {
    title: "Fair Housing | The Romanelli Group",
    description: "Fair Housing statement for The Romanelli Group.",
    keywords: "",
    ogTitle: "Fair Housing | The Romanelli Group",
    ogDescription: "Fair Housing statement for The Romanelli Group.",
    ogImage: "https://www.theromanelligroup.com/og-image.jpg",
    noindex: true,
  },

  "/accessibility-policy": {
    title: "Accessibility Policy | The Romanelli Group",
    description: "Accessibility Policy for The Romanelli Group.",
    keywords: "",
    ogTitle: "Accessibility Policy | The Romanelli Group",
    ogDescription: "Accessibility Policy for The Romanelli Group.",
    ogImage: "https://www.theromanelligroup.com/og-image.jpg",
    noindex: true,
  },
};